import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';
import { Button } from './Button';

/**
 * Icon-only light/dark switch for the global header. Shows the destination:
 * a sun while dark (click → light), a moon while light (click → dark). Uses the
 * shared Interstate `Button` (secondary / S) so it matches the Sign out button.
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const goingTo = theme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${goingTo} mode`;

  return (
    <Button
      variant="secondary"
      size="S"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      leftIcon={
        theme === 'dark' ? <SunIcon aria-hidden="true" /> : <MoonIcon aria-hidden="true" />
      }
    />
  );
}
